import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";

//Import Icons
import Icon from "@ailibs/feather-react-ts";

import { Link, useLocation, useNavigate } from "react-router-dom";

// Import menuDropdown
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import FilterBar from "./FilterBar";
import { useAgency } from "../Common/agencyBrandingData";
import Tour from "../Common/Tour";
import Sidebar from "./Sidebar";

const Header = (props: any) => {
  const navigate = useNavigate();
  const agency = useAgency();
  const { user } = useSelector((state: any) => state.login);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const location = useLocation();
  const isAnalyticsActive = location.pathname === '/analytics';
  const isReportsActive = location.pathname === '/reports';

  const agencyInfo = JSON.parse(localStorage.getItem("agencyInfo") || '{}');
  const topbarTheme = agencyInfo.data?.topbar_theme || 'light';
  const activeColor = topbarTheme === 'light' ? '#038edc' : '#f6f6f6';
  const inActiveColor = topbarTheme === 'light' ? '#555b6d' : '#917575';
  const allowedRoutes = ["/branding", "/clients", "/user-list", "/billing", "/team", "/analytics", "/reports", "/cortex-chat"];

  return (
    <React.Fragment>
      <Tour />
      <div className="navbar-header">
        <div className="d-flex">
          <div className="navbar-brand-box">
            <Link to="/analytics" className="logo logo-dark">
              <span className="logo-sm">
                <img src={agency.data.agency_logo} alt="" height="21" />
              </span>
              <span className="logo-lg">
                <img src={agency.data.agency_logo} alt="" height="35" />
              </span>
            </Link>
            <Link to="/analytics" className="logo logo-light">
              <span className="logo-sm">
                <img src={agency.data.agency_logo} alt="" height="23" />
              </span>
              <span className="logo-lg">
                <img src={agency.data.agency_logo} alt="" height="24" />
              </span>
            </Link>
          </div>
          {allowedRoutes.includes(location.pathname) && (
            <>
              <button
                type="button"
                className="btn btn-sm px-3 font-size-16 d-md-none header-item"
                onClick={() => setSidebarOpen(!sidebarOpen)}
                style={{ marginTop: "1px" }}
              >
                <i className="fa fa-fw fa-bars" />
              </button>
              <Sidebar
                isOpen={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
              />
            </>
          )}
          <div className="dropdown d-none d-md-block ms-2">
            <Link to="/analytics">
              <div className="header-item d-flex align-items-center justify-content-center analyticsjoy" style={{
                padding: '12px'
              }}>
                <span style={{ color: isAnalyticsActive ? activeColor : inActiveColor }}>Analytics</span>
              </div>
            </Link>
          </div>
          <div className="dropdown d-none d-md-block ms-2">
            <Link to="/reports">
              <div className="header-item d-flex align-items-center justify-content-center reportsjoy" style={{
                padding: '12px'
              }}>
                <span style={{ color: isReportsActive ? activeColor : inActiveColor }}>Reports</span>
              </div>
            </Link>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "8px" }}>
            <h6 className="agency-name" style={{ color: "rgb(85, 91, 109)", fontWeight: "normal", paddingRight: '12px' }}>{agency.data.agency_name}</h6>
          </div>
          <div className="d-flex ">
            <div className="dropdown d-inline-block">

              {((["admin", "AE", "AO"].includes(user.user.user_type)) || (user.user.permission_type == 'admin' && user.user.user_type == 'Client' && agencyInfo?.data.agency_name != 'Q1Media')) && (
                <button
                  type="button"
                  className="btn header-item noti-icon right-bar-toggle settingjoy "
                  onClick={() => navigate(((user.user.user_type == "admin") || (user.user.permission_type == 'admin' && user.user.user_type == 'Client')) ? '/branding' : '/clients')}
                  style={{ marginRight: "10px" }}
                >
                  <Icon
                    name="settings"
                    className="icon-sm"
                  />
                </button>
              )}
            </div>
            <ProfileMenu style={{
              marginRight: 10,
            }} />
          </div>
        </div>
      </div>
      <FilterBar />
    </React.Fragment>
  );
};

export default withTranslation()(Header);
